module.exports = __webpack_public_path__ + "static/media/body.bdd9bc3f.svg";